import {
  Checkbox,
  Container,
  FormControlLabel,
  Grid,
  Tooltip,
} from "@material-ui/core";
import { useContext, useEffect, useState } from "react";
import SelectErp from "../../../components/basics/SelectErp";
import Btn from "../../../components/buttons/Btn";
import Card from "../../../components/cards/Card";
import { Margin } from "../../financeiro/nfe/styles/Emissao";
import { TemplateEmailsContext } from "../contexts/TemplateEmailsContext";
import { DivHeandleEmail, IconHelp } from "../styles/ContentForm";
import useTemplatesEmailsController from "../controller/TemplatesEmailsController";
import TextField from "../../../components/basics/TextFieldErp";
import Timeline from "@material-ui/lab/Timeline";
import TimelineItem from "@material-ui/lab/TimelineItem";
import TimelineSeparator from "@material-ui/lab/TimelineSeparator";
import TimelineConnector from "@material-ui/lab/TimelineConnector";
import TimelineContent from "@material-ui/lab/TimelineContent";
import TimelineDot from "@material-ui/lab/TimelineDot";
import ModalHeaders from "./ModalHeaders";
import ModalFooters from "./ModalFooters";
import EditorTiny from "../../../components/inputs/EditorTiny";
import { QueryParamsContext } from "../../../context/QueryParamsContext";
import { useHistory } from "react-router-dom";
import { notify } from "../../../utils/notify";

const ContentForm = ({ location }) => {
  const {
    routine,
    setRoutine,
    bodyEditor,
    setBodyEditor,
    typesList,
    hiddenCopy,
    setHiddenCopy,
    title,
    setTitle,
    subject,
    setSubject,
    setHeader,
    setFooter,
    headerHeandle,
    footerHeandle,
    setTemplateDescription,
    templateDescription,
    setHeaderSelected,
    setFooterSelected,
    setFooterHeandle,
  } = useContext(TemplateEmailsContext);

  const [modalHeader, setModalHeader] = useState(false);
  const [modalFooter, setModalFooter] = useState(false);
  const [disabledEditor, setDisabledEditor] = useState(false);
  const { queryParams } = useContext(QueryParamsContext);
  const { push } = useHistory();

  const { initHeandleInputs, store, heandleTemplateEmail, update, destroy } =
    useTemplatesEmailsController();

  useEffect(() => {
    if (queryParams.empresa_cnpj) initHeandleInputs("type");
  }, [initHeandleInputs, queryParams.empresa_cnpj]);

  useEffect(() => {
    if (location?.state?.item) {
      heandleTemplateEmail(location?.state?.item);
      setDisabledEditor(true);
    }
  }, [location, heandleTemplateEmail]);

  const clearContext = () => {
    setRoutine("");
    setTemplateDescription("");
    setBodyEditor("");
    setTitle("");
    setSubject("");
    setHiddenCopy("");
    setHeaderSelected("");
    setFooterSelected("");
    setFooterHeandle("");
  };

  const insertParamsInOnChangeEditor = (newValue) => {
    if (routine?.parameters) {
      let paramCopy = JSON.parse(routine?.parameters);

      paramCopy.forEach((data, index) => {
        let html =
          '"<span style="background-color: #fbeeb8;">' +
          data?.string +
          '</span>"';
        let rgxp = new RegExp(html, "g");

        paramCopy[index]["defined"] = newValue.match(rgxp) !== null;
      });

      paramCopy = JSON.stringify(paramCopy);

      let newRoutine = routine;
      newRoutine["parameters"] = paramCopy;

      setBodyEditor(newValue);
      setRoutine(newRoutine);
    }
  };

  const insertParamsInEditor = (data, index) => {
    if (routine?.parameters) {
      let paramCopy = JSON.parse(routine?.parameters);
      paramCopy[index]["defined"] = true;
      paramCopy = JSON.stringify(paramCopy);

      let newRoutine = routine;
      newRoutine["parameters"] = paramCopy;

      setBodyEditor(
        bodyEditor +
          '"<span style="background-color: #fbeeb8;">' +
          data?.string +
          '</span>"'
      );
      setRoutine(newRoutine);
    }
  };

  const CheckJsonParameters = () => {
    var checks = null;

    if (routine?.parameters) {
      checks = JSON.parse(routine?.parameters).map((data, index) => {
        return (
          <div key={index}>
            <Grid item container xs>
              <FormControlLabel
                control={
                  <Checkbox
                    onClick={() => insertParamsInEditor(data, index)}
                    checked={data?.defined}
                    name={data?.parameter}
                    color="primary"
                  />
                }
                label={data?.string + (data?.require ? " *" : "")}
              />
            </Grid>
          </div>
        );
      });
    }
    return <>{checks}</>;
  };

  const validationParams = () => {
    var success = true;

    if (routine?.parameters) {
      var parameters = JSON.parse(routine?.parameters);

      parameters.forEach((data) => {
        if (data?.require && !data?.defined) return (success = false);
      });
    }

    if (!success)
      notify("Há parametros obrigatórios que não foram incluídos no email.");

    return { success: success };
  };

  const handleSave = async () => {
    let callback = validationParams();

    if (callback?.success) {
      if (location?.state?.item?.id) {
        await update("templatesEmails", location);
      } else await store("templatesEmails");

      push("listagem");
      clearContext();
    }
  };

  const handleDestroy = async () => {
    if (location?.state?.item?.id) await destroy("templatesEmails", location);

    push("listagem");
    clearContext();
  };

  return (
    <>
      {modalHeader && (
        <ModalHeaders
          open={modalHeader}
          setContent={setHeader}
          setOpen={setModalHeader}
        />
      )}
      {modalFooter && (
        <ModalFooters
          open={modalFooter}
          setContent={setFooter}
          setOpen={setModalFooter}
        />
      )}
      <Margin top={80}>
        <Container maxWidth="xl">
          <Grid item container spacing={1}>
            <Card fullWidth={true}>
              <Grid item container xs={12} spacing={2}>
                <Grid item xs={4}>
                  <SelectErp
                    error={false}
                    loading={false}
                    label="Rotina"
                    value={routine}
                    setValue={setRoutine}
                    optionsList={typesList}
                    descriptionField="label"
                    variant="filled"
                  />
                </Grid>
                <Grid item xs />
                <Grid item xs={2}>
                  <Btn
                    label="CABEÇALHO"
                    onClick={() => setModalHeader(true)}
                    fullWidth={true}
                    bgcolor="primary"
                  />
                </Grid>
                <Grid item xs={2}>
                  <Btn
                    label="RODAPÉ"
                    onClick={() => setModalFooter(true)}
                    fullWidth={true}
                    bgcolor="primary"
                  />
                </Grid>
              </Grid>
              <Grid item xs={6}>
                <Timeline>
                  <TimelineItem>
                    <TimelineSeparator>
                      <TimelineDot />
                      <TimelineConnector />
                    </TimelineSeparator>
                    <TimelineContent>Descrição:</TimelineContent>
                    <Grid item container xs={6}>
                      <Grid item container xs>
                        <TextField
                          label="Descrição"
                          variant="filled"
                          type="text"
                          size="small"
                          setValue={setTemplateDescription}
                          value={templateDescription}
                        />
                      </Grid>
                      <Grid item container xs={1}>
                        <Tooltip title="Descrição do email.">
                          <IconHelp />
                        </Tooltip>
                      </Grid>
                    </Grid>
                  </TimelineItem>
                  <TimelineItem>
                    <TimelineSeparator>
                      <TimelineDot />
                      <TimelineConnector />
                    </TimelineSeparator>
                    <TimelineContent>Cópia Oculta:</TimelineContent>
                    <Grid item container xs={6}>
                      <Grid item container xs>
                        <TextField
                          label="Emails para cópia oculta"
                          variant="filled"
                          type="text"
                          size="small"
                          setValue={setHiddenCopy}
                          value={hiddenCopy}
                        />
                      </Grid>
                      <Grid item container xs={1}>
                        <Tooltip title="Emails para cópia oculta, seperar com vírgula!">
                          <IconHelp />
                        </Tooltip>
                      </Grid>
                    </Grid>
                  </TimelineItem>
                  <TimelineItem>
                    <TimelineSeparator>
                      <TimelineDot />
                      <TimelineConnector />
                    </TimelineSeparator>
                    <TimelineContent>Título:</TimelineContent>
                    <Grid item container xs={6}>
                      <Grid item container xs>
                        <TextField
                          label="Título"
                          variant="filled"
                          type="text"
                          size="small"
                          setValue={setTitle}
                          value={title}
                        />
                      </Grid>
                      <Grid item container xs={1}>
                        <Tooltip title="Título do email.">
                          <IconHelp />
                        </Tooltip>
                      </Grid>
                    </Grid>
                  </TimelineItem>
                  <TimelineItem>
                    <TimelineSeparator>
                      <TimelineDot />
                    </TimelineSeparator>
                    <TimelineContent>Assunto do email:</TimelineContent>
                    <Grid item container xs={6}>
                      <Grid item container xs>
                        <TextField
                          label="Assunto"
                          variant="filled"
                          type="text"
                          size="small"
                          setValue={setSubject}
                          value={subject}
                        />
                      </Grid>
                      <Grid item container xs={1}>
                        <Tooltip title="Assunto do email.">
                          <IconHelp />
                        </Tooltip>
                      </Grid>
                    </Grid>
                  </TimelineItem>
                </Timeline>
              </Grid>
              <Card fullWidth={true} line="left">
                <DivHeandleEmail
                  dangerouslySetInnerHTML={{ __html: headerHeandle }}
                />
                <DivHeandleEmail>
                  <EditorTiny
                    value={bodyEditor}
                    setValue={setBodyEditor}
                    disabled={disabledEditor}
                    onEditorChange={(newValue) =>
                      insertParamsInOnChangeEditor(newValue)
                    }
                  />
                  {routine?.value && (
                    <Grid item container xs={12}>
                      <Card fullWidth={true} line="left">
                        <Grid item container xs={12}>
                          <CheckJsonParameters />
                        </Grid>
                      </Card>
                    </Grid>
                  )}
                </DivHeandleEmail>
                <DivHeandleEmail
                  dangerouslySetInnerHTML={{ __html: footerHeandle }}
                />
              </Card>
              <Margin top={10}>
                <Grid item container xs spacing={1}>
                  <Grid item xs />
                  {location?.state?.item?.id && disabledEditor && (
                    <Grid item xs={1}>
                      <Btn
                        label="Editar"
                        onClick={() => setDisabledEditor(false)}
                        fullWidth={true}
                        bgcolor="primary"
                      />
                    </Grid>
                  )}
                  {location?.state?.item?.id && !disabledEditor && (
                    <Grid item xs={1}>
                      <Btn
                        label="EXCLUIR"
                        onClick={handleDestroy}
                        fullWidth={true}
                        bgcolor="darkred"
                      />
                    </Grid>
                  )}
                  {routine?.value &&
                    templateDescription &&
                    bodyEditor &&
                    !disabledEditor && (
                      <Grid item xs={1}>
                        <Btn
                          label="SALVAR"
                          onClick={handleSave}
                          fullWidth={true}
                          bgcolor="primary"
                        />
                      </Grid>
                    )}
                  <Grid item xs={1}>
                    <Btn
                      label="CANCELAR"
                      onClick={() => {
                        push("listagem");
                        clearContext();
                      }}
                      fullWidth={true}
                      bgcolor="grey"
                    />
                  </Grid>
                </Grid>
              </Margin>
            </Card>
          </Grid>
        </Container>
      </Margin>
    </>
  );
};

export default ContentForm;
